import { render, staticRenderFns } from "./EditIdNumber.vue?vue&type=template&id=220dea1c&"
import script from "./EditIdNumber.vue?vue&type=script&lang=js&"
export * from "./EditIdNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports